import React from 'react';
import { motion } from 'framer-motion';
import { STEPS } from '../../data/content';

export default function HowItWorks() {
  return (
    <section id="process" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-16">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-teal mb-4">
            — How It Works —
          </p>
          <h2 className="font-display font-black text-4xl md:text-5xl lg:text-6xl tracking-tighter max-w-3xl">
            From Enquiry to<br />Execution in <span className="text-teal">5 Steps.</span>
          </h2>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px timeline-line hidden md:block" />
          <div className="space-y-10 md:space-y-16">
            {STEPS.map((s, i) => (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-80px' }}
                transition={{ delay: 0.05 * i, duration: 0.5 }}
                data-testid={`how-step-${s.n}`}
                className={`grid md:grid-cols-2 gap-6 md:gap-20 items-center ${
                  i % 2 === 1 ? 'md:[&>*:first-child]:order-2' : ''
                }`}
              >
                <div className={i % 2 === 1 ? 'md:text-right' : ''}>
                  <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-teal mb-3">
                    Step {s.n}
                  </div>
                  <h3 className="font-display font-bold text-3xl md:text-4xl text-white tracking-tight mb-3">
                    {s.title}
                  </h3>
                  <p className="text-white/65 leading-relaxed max-w-md md:inline-block">
                    {s.desc}
                  </p>
                </div>
                <div className="hidden md:flex items-center justify-center">
                  <div className="relative w-16 h-16 rounded-full glass-strong flex items-center justify-center">
                    <div className="absolute inset-0 rounded-full bg-teal/10 animate-pulse" />
                    <span className="relative font-display font-black text-xl text-teal">
                      {s.n}
                    </span>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
